
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.188 0H2.813A2.816 2.816 0 000 2.813v18.375A2.816 2.816 0 002.813 24h18.375A2.816 2.816 0 0024 21.187V2.813A2.816 2.816 0 0021.187 0zm.937 21.188c0 .516-.42.937-.938.937h-5.53v-6.844h3l.35-2.906h-3.35v-3.14c0-.802.604-1.407 1.405-1.407h2.11V5.11c-.555-.078-1.626-.187-2.11-.187-1.093 0-2.189.461-3.006 1.265-.842.829-1.306 1.914-1.306 3.056v3.132H9.703v2.906h3.047v6.844H2.812a.939.939 0 01-.937-.938V2.813c0-.516.42-.937.938-.937h18.375c.516 0 .937.42.937.938v18.375z"}})])
          )
        }
      }
    